import { StyleSheet } from '@react-pdf/renderer';

// PDF styles following SnapGrade email template design with Tailwind-inspired colors
const styles = StyleSheet.create({
  // Page and container styles
  page: {
    padding: 0,
    fontFamily: 'Helvetica',
    fontSize: 12,
    backgroundColor: '#ffffff',
  },
  
  // COMPACT STYLES FOR 1/4 A4 PAGE
  // Compact header with minimal spacing
  compactHeader: {
    backgroundColor: '#F0D143',
    padding: '8px 15px',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  
  // Compact structured header (keeps the card layout)
  compactStructuredHeader: {
    backgroundColor: '#F0D143',
    padding: '12px 20px',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  
  compactLogo: {
    height: 25,
    objectFit: 'contain',
  },
  
  // Compact centered logo (positioned in center-left area)
  compactCenteredLogo: {
    height: 90,
    objectFit: 'contain',
    marginLeft: 85,
    marginRight: 'auto',
  },
  
  compactHeaderInfo: {
    flex: 1,
    paddingLeft: 15,
  },
  
  // Compact header right container (smaller width)
  compactHeaderRightContainer: {
    width: 300,
    paddingLeft: 30,
    flexDirection: 'column',
  },
  
  // Compact header info card
  compactHeaderInfoCard: {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    padding: 8,
    borderRadius: 3,
    marginBottom: 0,
    width: '100%',
  },
  
  // Compact header card title
  compactHeaderCardTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#1f2937',
    marginBottom: 6,
    textAlign: 'center',
  },
  
  // Compact header info row
  compactHeaderInfoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 3,
  },
  
  // Compact header info label
  compactHeaderInfoLabel: {
    fontSize: 9,
    color: '#4b5563',
    fontWeight: 'bold',
    flex: 1,
  },
  
  // Compact header info value
  compactHeaderInfoValue: {
    fontSize: 9,
    color: '#111827',
    flex: 2,
    textAlign: 'right',
  },
  
  // Compact generated info in header (below submission info card)
  compactGeneratedInfoHeader: {
    fontSize: 7,
    color: '#4b5563',
    textAlign: 'right',
    marginTop: 6,
    fontStyle: 'italic',
  },
  
  compactHeaderText: {
    fontSize: 9,
    color: '#1f2937',
    lineHeight: 1.2,
    marginBottom: 2,
  },
  
  // Compact main container
  compactContainer: {
    padding: '0 15px',
    maxWidth: '100%',
  },
  
  // Compact title
  compactTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#1f2937',
    marginBottom: 8,
    textAlign: 'center',
  },
  
  // Compact title container (for inline layout)
  compactTitleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  
  // Compact title center wrapper (to keep title centered)
  compactTitleCenterWrapper: {
    flex: 1,
    alignItems: 'center',
  },
  
  // Compact title (when inline)
  compactTitleInline: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#1f2937',
    flex: 1,
    textAlign: 'center',
  },
  
  // Compact question section
  compactQuestionSection: {
    marginBottom: 12,
    border: '1px solid #e5e7eb',
    borderRadius: 3,
    overflow: 'hidden',
  },
  
  // Compact question header - inline question and score
  compactQuestionHeader: {
    backgroundColor: '#f9fafb',
    padding: '6px 8px',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderBottom: '1px solid #e5e7eb',
  },
  
  // Compact question title with inline question text
  compactQuestionTitle: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#1f2937',
    flex: 1,
    lineHeight: 1.3,
    paddingRight: 8,
  },
  
  // Compact question score
  compactQuestionScore: {
    fontSize: 8,
    fontWeight: 'bold',
    color: '#4b5563',
    backgroundColor: '#ffffff',
    padding: '2px 6px',
    borderRadius: 2,
    minWidth: 35,
    textAlign: 'center',
  },
  
  // Compact feedback container
  compactFeedbackContainer: {
    padding: '8px 8px 6px 8px',
  },
  
  // Compact feedback section
  compactFeedbackSection: {
    marginBottom: 6,
  },
  
  // Compact feedback label
  compactFeedbackLabel: {
    fontSize: 8,
    fontWeight: 'bold',
    color: '#4b5563',
    marginBottom: 2,
  },
  
  // Compact feedback text
  compactFeedbackText: {
    fontSize: 8,
    color: '#000000',
    lineHeight: 1.4,
    padding: '4px 6px',
    backgroundColor: '#fefce8',
    borderLeft: '2px solid #F0D143',
    borderRadius: 2,
  },
  
  // Compact flagged warning
  compactFlaggedWarning: {
    backgroundColor: '#fee2e2',
    padding: '4px 6px',
    marginBottom: 4,
    borderRadius: 2,
  },
  
  // Compact flagged text
  compactFlaggedText: {
    fontSize: 8,
    fontWeight: 'bold',
    color: '#991b1b',
    lineHeight: 1.2,
  },
  
  // Compact generated info
  compactGeneratedInfo: {
    fontSize: 7,
    color: '#6b7280',
    textAlign: 'center',
    marginTop: 12,
    paddingTop: 8,
    borderTop: '1px solid #e5e7eb',
  },
  
  // Compact generated info at top (after title)
  compactGeneratedInfoTop: {
    fontSize: 7,
    color: '#6b7280',
    textAlign: 'right',
    marginBottom: 8,
    marginTop: 2,
  },
  
  // Compact generated info inline (positioned at far right)
  compactGeneratedInfoInline: {
    fontSize: 7,
    color: '#6b7280',
    textAlign: 'right',
    position: 'absolute',
    right: 0,
    top: 2,
  },
  
  // Compact generated info on same line as title
  compactGeneratedInfoSameLine: {
    fontSize: 7,
    color: '#6b7280',
    textAlign: 'right',
  },

  // GRID LAYOUT STYLES FOR 2x2 QUESTIONS
  // Grid container for 2x2 layout
  gridContainer: {
    padding: '0 10px',
    flex: 1,
  },

  // Grid row container (contains 2 questions side by side)
  gridRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
    minHeight: 180, // Fixed height instead of percentage to ensure consistency
  },

  // Grid question cell (1/4 of the page)
  gridQuestionCell: {
    width: '48%', // Slightly less than 50% to account for gap
    border: '1px solid #e5e7eb',
    borderRadius: 3,
    overflow: 'hidden',
    backgroundColor: '#ffffff',
    flexDirection: 'column',
    minHeight: 180, // Ensure consistent height
  },

  // Grid question header
  gridQuestionHeader: {
    backgroundColor: '#f9fafb',
    padding: '6px 8px',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderBottom: '1px solid #e5e7eb',
    minHeight: 35,
  },

  // Grid question title (bigger text for readability)
  gridQuestionTitle: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#1f2937',
    flex: 1,
    lineHeight: 1.3,
    paddingRight: 6,
  },

  // Grid question score
  gridQuestionScore: {
    fontSize: 8,
    fontWeight: 'bold',
    color: '#4b5563',
    backgroundColor: '#ffffff',
    padding: '2px 6px',
    borderRadius: 2,
    minWidth: 30,
    textAlign: 'center',
  },

  // Grid feedback container
  gridFeedbackContainer: {
    padding: '6px 8px',
    flex: 1,
    overflow: 'hidden',
  },

  // Grid feedback section
  gridFeedbackSection: {
    marginBottom: 4,
  },

  // Grid feedback label
  gridFeedbackLabel: {
    fontSize: 8,
    fontWeight: 'bold',
    color: '#4b5563',
    marginBottom: 2,
  },

  // Grid feedback text
  gridFeedbackText: {
    fontSize: 8,
    color: '#000000',
    lineHeight: 1.4,
    padding: '3px 5px',
    backgroundColor: '#fefce8',
    borderLeft: '2px solid #F0D143',
    borderRadius: 2,
  },

  // Grid flagged warning
  gridFlaggedWarning: {
    backgroundColor: '#fee2e2',
    padding: '3px 5px',
    marginBottom: 3,
    borderRadius: 2,
  },

  // Grid flagged text
  gridFlaggedText: {
    fontSize: 8,
    fontWeight: 'bold',
    color: '#991b1b',
    lineHeight: 1.3,
  },
  
  // ORIGINAL STYLES (keeping for backward compatibility)
  // Header with yellow background (like email template) - equivalent to bg-yellow-300
  header: {
    backgroundColor: '#F0D143',
    padding: '25px 40px',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  
  logo: {
    height: 70,
    objectFit: 'contain',
  },
  
  // Header right side container
  headerRightContainer: {
    flex: 1,
    paddingLeft: 40,
    flexDirection: 'column',
    gap: 10,
  },
  
  // Header info card (compact version for header)
  headerInfoCard: {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    padding: 12,
    borderRadius: 4,
    marginBottom: 0,
  },
  
  // Header card title
  headerCardTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#1f2937',
    marginBottom: 8,
  },
  
  // Header card title centered
  headerCardTitleCentered: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#1f2937',
    marginBottom: 8,
    textAlign: 'center',
  },
  
  // Header info row
  headerInfoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 4,
  },
  
  // Header info label
  headerInfoLabel: {
    fontSize: 12,
    color: '#4b5563',
    fontWeight: 'bold',
    flex: 1,
  },
  
  // Header info value
  headerInfoValue: {
    fontSize: 12,
    color: '#111827',
    flex: 2,
    textAlign: 'right',
  },
  
  // Header score text
  headerScoreText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#000000',
    textAlign: 'center',
    marginBottom: 8,
  },
  

  
  // Main container - equivalent to max-w-2xl mx-auto px-10
  container: {
    padding: '0 40px',
    maxWidth: 600,
    margin: '0 auto',
  },
  
  // Top info section
  topInfo: {
    fontSize: 12,
    color: '#4b5563',
    textAlign: 'right',
    marginBottom: 15,
    padding: '10px 0',
    borderBottom: '1px solid #e5e7eb',
  },
  
  // Two column layout for submission info and score
  twoColumnContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
    gap: 15,
  },
  
  // Left column (submission info)
  leftColumn: {
    flex: 1,
  },
  
  // Right column (score summary)
  rightColumn: {
    flex: 1,
  },
  
  // Information cards - equivalent to bg-gray-50 p-5 rounded border border-gray-200 mb-5
  infoCard: {
    backgroundColor: '#f9fafb', // bg-gray-50
    padding: 15,
    borderRadius: 4,
    marginBottom: 15,
    border: '1px solid #e5e7eb', // border-gray-200
  },
  
  // Card title - equivalent to text-base font-bold text-gray-800 mb-4
  infoCardTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1f2937', // text-gray-800
    marginBottom: 12,
  },
  
  // Info row - equivalent to flex justify-between mb-2 pb-1
  infoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
    paddingBottom: 5,
  },
  
  // Label - equivalent to text-sm text-gray-600 font-semibold flex-1
  infoLabel: {
    fontSize: 14,
    color: '#4b5563', // text-gray-600
    fontWeight: 'bold',
    flex: 1,
  },
  
  // Value - equivalent to text-sm text-gray-900 flex-2 text-right
  infoValue: {
    fontSize: 14,
    color: '#111827', // text-gray-900
    flex: 2,
    textAlign: 'right',
  },
  
  // Score highlight - text only, no background
  scoreHighlight: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#000000',
    textAlign: 'center',
    marginBottom: 10,
  },
  
  // Progress bar container
  progressBarContainer: {
    marginBottom: 5,
    marginTop: 5,
  },
  
  // Progress bar background
  progressBarBackground: {
    height: 20,
    backgroundColor: '#e5e7eb', // light gray
    borderRadius: 4,
    position: 'relative',
    overflow: 'hidden',
  },
  
  // Progress bar fill
  progressBarFill: {
    height: 20,
    backgroundColor: '#F0D143', // yellow
    borderRadius: 4,
    position: 'absolute',
    top: 0,
    left: 0,
  },
  
  // Progress bar text overlay
  progressBarText: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#000000',
    textAlign: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 20,
    lineHeight: 1.8,
  },
  
  // Question section - equivalent to mb-8 border border-gray-200 rounded overflow-hidden
  questionSection: {
    marginBottom: 20,
    border: '1px solid #e5e7eb', // border-gray-200
    borderRadius: 4,
    overflow: 'hidden',
  },
  
  // Question header - equivalent to bg-gray-50 p-4 border-b border-gray-200 flex justify-between items-center
  questionHeader: {
    backgroundColor: '#f9fafb', // bg-gray-50
    padding: 15,
    borderBottom: '1px solid #e5e7eb', // border-gray-200
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  
  // Question title - equivalent to text-base font-bold text-gray-800
  questionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1f2937', // text-gray-800
  },
  
  // Question score badge - equivalent to text-sm font-bold text-gray-600 bg-white px-2 py-1 rounded
  questionScore: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#4b5563', // text-gray-600
    backgroundColor: '#ffffff',
    padding: '5px 10px',
    borderRadius: 4,
  },
  
  // Question content - equivalent to p-5
  questionContent: {
    padding: 20,
  },
  
  // Question text - equivalent to text-sm text-gray-800 leading-relaxed mb-4 bg-gray-50 p-4 rounded
  questionText: {
    fontSize: 14,
    color: '#1f2937', // text-gray-800
    lineHeight: 1.6,
    marginBottom: 15,
    backgroundColor: '#f9fafb', // bg-gray-50
    padding: 15,
    borderRadius: 4,
  },
  
  // Section label - equivalent to text-sm font-bold text-gray-800 mb-2 mt-4
  sectionLabel: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#1f2937', // text-gray-800
    marginBottom: 8,
    marginTop: 15,
  },
  
  // Answer text - equivalent to text-xs text-black leading-relaxed mb-4 p-4 bg-blue-50 border-l-4 border-blue-500 rounded
  answerText: {
    fontSize: 13,
    color: '#000000',
    lineHeight: 1.6,
    marginBottom: 15,
    padding: 15,
    backgroundColor: '#eff6ff', // bg-blue-50
    borderLeft: '4px solid #3b82f6', // border-blue-500
    borderRadius: 4,
  },
  
  // Feedback text - equivalent to text-xs text-black leading-relaxed mb-2 p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded
  feedbackText: {
    fontSize: 13,
    color: '#000000',
    lineHeight: 1.6,
    marginBottom: 10,
    padding: 15,
    backgroundColor: '#fefce8', // bg-yellow-50
    borderLeft: '4px solid #F0D143', // border-yellow-400
    borderRadius: 4,
  },
  
  // Status badge base - equivalent to text-xs font-bold px-2 py-1 rounded text-center mb-2
  statusBadge: {
    fontSize: 12,
    fontWeight: 'bold',
    padding: '5px 10px',
    borderRadius: 4,
    textAlign: 'center',
    marginBottom: 10,
  },
  
  // Status graded - equivalent to bg-green-100 text-green-800
  statusGraded: {
    backgroundColor: '#dcfce7', // bg-green-100
    color: '#166534', // text-green-800
  },
  
  // Status pending - equivalent to bg-yellow-100 text-yellow-800
  statusPending: {
    backgroundColor: '#fef3c7', // bg-yellow-100
    color: '#92400e', // text-yellow-800
  },
  

  
  // Flagged content warning - equivalent to bg-red-100 text-red-800 p-4 rounded mb-4 border border-red-200
  flaggedWarning: {
    backgroundColor: '#fee2e2', // bg-red-100
    color: '#991b1b', // text-red-800
    padding: 15,
    borderRadius: 4,
    marginBottom: 15,
    border: '1px solid #fecaca', // border-red-200
  },
  
  // Flagged text - equivalent to text-xs font-bold mb-1
  flaggedText: {
    fontSize: 13,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  
  // Utility styles
  centerText: {
    textAlign: 'center',
  },
  
  boldText: {
    fontWeight: 'bold',
  },
  
  spacer: {
    marginBottom: 20,
  },
  
  // Small text - equivalent to text-xs text-gray-600
  smallText: {
    fontSize: 11,
    color: '#4b5563', // text-gray-600
  },
});

export default styles; 